import { render, staticRenderFns } from "./therm-v2-defects-list.vue?vue&type=template&id=5abcc38f"
import script from "./therm-v2-defects-list.vue?vue&type=script&lang=js"
export * from "./therm-v2-defects-list.vue?vue&type=script&lang=js"
import style0 from "./therm-v2-defects-list.vue?vue&type=style&index=0&id=5abcc38f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports